import { LOGIN_NOTICES, type LoginNotice } from "./guards";

export interface LoginSearch {
  redirect?: string;
  notice?: LoginNotice;
  ref?: string;
}

export interface RegisterSearch {
  redirect?: string;
  ref?: string;
}

const str = (v: unknown, max = 2000) =>
  typeof v === "string" && v.length > 0 && v.length <= max ? v : undefined;

/** Search params of `/app/login` and `/portal/login` (FE-01 §6.1). */
export function validateLoginSearch(search: Record<string, unknown>): LoginSearch {
  const notice = LOGIN_NOTICES.find((n) => n === search.notice);
  return { redirect: str(search.redirect), notice, ref: str(search.ref, 20) };
}

/** Search params of `/app/register` (FE-01 §6.1, FE-05 FR-FE05-14). */
export function validateRegisterSearch(search: Record<string, unknown>): RegisterSearch {
  return { redirect: str(search.redirect), ref: str(search.ref, 20) };
}
